import { format } from "date-fns";

const generateSubscriptionInvoiceNumber = (invoicePattern) => {
	const currentIime = Date.now();
	const date = format(new Date(currentIime), "yyMMdd");
	return `${invoicePattern}`.replace(
		"%",
		`${date}-${currentIime.toString().slice(-4)}`,
	);
};

export { generateSubscriptionInvoiceNumber };
